import axios from "axios";

const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || "/api/v1";

// Create axios instance with interceptors
const api = axios.create({
  baseURL: API_BASE_URL,
});

// Add request interceptor to include auth token
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

// Add response interceptor for error handling (without redirect)
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // Clear storage and dispatch logout to Redux
      localStorage.removeItem("token");
      localStorage.removeItem("user");

      // Dispatch logout action to update Redux state
      //if (store && logoutAction) {
      //  store.dispatch(logoutAction());
      //}
    }
    return Promise.reject(error);
  },
);

export const login = async (credentials) => {
  try {
    // OAuth2 password flow requires form data
    const formData = new FormData();
    formData.append("username", credentials.username);
    formData.append("password", credentials.password);

    const response = await api.post("/auth/login", formData, {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
    });
    return { data: response.data };
  } catch (error) {
    throw error;
  }
};

export const logout = async () => {
  try {
    // Clear local storage
    localStorage.removeItem("token");
    localStorage.removeItem("user");
    return Promise.resolve();
  } catch (error) {
    throw new Error("Logout failed");
  }
};

export const getCurrentUser = async () => {
  try {
    const response = await api.get(`/users/me`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const updateUser = async (userData) => {
  try {
    const response = await api.put(`/users/me`, userData);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const toggleUserNotifications = async () => {
  try {
    const response = await api.post(`/users/me/toggle-notifications`);
    return response.data;
  } catch (error) {
    throw error;
  }
};
